import apiClient from './api';

export interface University {
  id: number;
  name: string;
}

export interface Department {
  id: number;
  name: string;
}

export const universityService = {
  getUniversities: async (): Promise<University[]> => {
    const response = await apiClient.get<University[]>('/universities');
    return response.data;
  },

  getDepartments: async (universityId: number): Promise<Department[]> => {
    const response = await apiClient.get<Department[]>(`/universities/${universityId}/departments`);
    return response.data;
  },
};
